import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField, MenuItem } from "@mui/material";
import SplitNumber from "../_Components/SplitNumber";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { Link } from "react-router-dom";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { useNavigate, useLocation } from "react-router-dom";
import { ViewModal } from "./ViewModal";
import DataGrid from "./DataGrid";
import { AddModal } from "./AddModal";
import ApiAgency from "../../../core/api/api.agency";
import ApiAccount from "../../../core/api/api.account";
import { tools } from "../../../core/utils/tools";
const AgencyTransaction = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const [showModalAgencyTransaction, setShowModalAgencyTransaction] = useState(false);
  const [selectedAgencyTransaction, setSelectedAgencyTransaction] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [lAgency, setLAgency] = useState([]);
  const [lAccount, setLAccount] = useState([]);
  const [agency, setAgency] = useState({});
  const watchAgencyId = watch("agencyId", undefined);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const [fromCreatedDate, setfromCreatedDate] = useState();
  const [toCreatedDate, settoCreatedDate] = useState();
  const [fromCompletionDate, setfromCompletionDate] = useState();
  const [toCompletionDate, settoCompletionDate] = useState();
  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست آژانس ها
        const data1 = await ApiAgency.getAllAgency({ PageNumber: 1, PageSize: 100 });
        setLAgency(data1.data);
        const apiData = await ApiAgency.getAgencyTransaction({
          agencyId: searchParams.get("agencyId"),
          accountId: searchParams.get("accountId"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          fromCompletionDate: searchParams.get("fromCompletionDate"),
          toCompletionDate: searchParams.get("toCompletionDate"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setListData(apiData);
        setValue("totalCount", apiData.totalCount);
        if (!_.isEmpty(searchParams.get("agencyId"))) {
          const apiAgency = await ApiAgency.getAgencyById(searchParams.get("agencyId"));
          setAgency(apiAgency.data);
        }
        const formInputs = [
          { name: "agencyId", type: "text" },
          { name: "accountId", type: "text" },
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "fromCompletionDate", type: "datePicker" },
          { name: "toCompletionDate", type: "datePicker" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    (async () => {
      // دریافت لیست حساب ها
      if (watchAgencyId != undefined) {
        let response = await ApiAccount.getAccountByAgencyId(watchAgencyId);
        setLAccount(response.data);
      }
    })();
    return () => { };
  }, [watchAgencyId]);

  const onSubmit = async (data) => {
    data.pageNumber = getValues("pageNumber");
    if (data.fromCreatedDate !== null && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate !== null && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    if (data.fromCompletionDate !== null && typeof data.fromCompletionDate === "object") {
      data.fromCompletionDate = tools.DateFormat(data.fromCompletionDate);
    }
    if (data.toCompletionDate !== null && typeof data.toCompletionDate === "object") {
      data.toCompletionDate = tools.DateFormat(data.toCompletionDate);
    }
    tools.setPageNumber(data, searchParams, setValue);
    const apiAgency = await ApiAgency.getAgencyById(data.agencyId);
    setAgency(apiAgency.data);

    const apiData = await ApiAgency.getAgencyTransaction(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/agencyTransaction?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست تراکنش های مرتبط به یک آژانس خاص</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تراکنش های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Link
              className="btn btn-success"
              variant="success"
              key={0}
              to={{
                pathname: `/agencyTransaction/0`,
                state: { id: 0 },
              }}
            >
              <AddCircle className="mr-1" />
              افزودن تراکنش
            </Link>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search Advance box */}
              <Accordion>
                <Card>
                  <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                    <Card.Title className="py-0 pl-0">جستجو پیشرفته</Card.Title>
                  </Accordion.Header>
                  <Accordion.Body eventKey="0" className="show">
                    <Card.Body>
                      <Row>
                        <Col lg="6" xs="12" className="tb-reponsive  px-2">
                          <Controller
                            name="agencyId"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                select
                                label="انتخاب آژانس"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={value || ""}
                                onInput={onChange}
                                onChange={onChange}
                              >
                                <MenuItem key={99} value={0}>
                                  {" "}
                                  --{" "}
                                </MenuItem>
                                {lAgency?.map((item, index) => (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}{" "}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                          {errors.agencyId && <small className="text-danger">لطفا آژانس را انتخاب نمایید</small>}
                        </Col>
                        <Col lg="6" xs="12" className="tb-reponsive px-2">
                          <Controller
                            name="accountId"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                select
                                label="انتخاب حساب"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={value || ""}
                                onInput={onChange}
                                onChange={onChange}
                              >
                                <MenuItem key={99} value={0}>
                                  {" "}
                                  --{" "}
                                </MenuItem>
                                {lAccount?.map((item, index) => (
                                  <MenuItem key={index} value={item.id}>
                                    {"نام : " + item.accountOwnerName + " - شماره کارت : " + item.accountNumber}{" "}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6" xs="12" className="tb-reponsive px-2">
                          <Controller
                            name="fromCreatedDate"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <ShamsiDatePicker
                                value={value}
                                placeholder=" از تاریخ ایجاد"
                                onChange={(date) => {
                                  var toCreatedDate = getValues("toCreatedDate");
                                  onChange(date);
                                  if (
                                    !toCreatedDate ||
                                    date?.toDate()?.getTime() > new Date(toCreatedDate).getTime()
                                  ) {
                                    // Set the value of toCreatedDate to the same as toCreatedDate
                                    setValue("toCreatedDate", date);
                                  }
                                }}
                              />
                            )}
                          />
                        </Col>
                        <Col lg="6" xs="12" className="tb-reponsive px-2">
                          <Controller
                            name="toCreatedDate"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <ShamsiDatePicker value={value} onChange={onChange} placeholder="تا تاریخ ایجاد" />
                            )}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6" xs="12" className="tb-reponsive px-2">
                          <Controller
                            name="fromCompletionDate"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <ShamsiDatePicker
                                value={value}
                                placeholder=" از تاریخ موثر"
                                onChange={(date) => {
                                  var toCompletionDate = getValues("toCompletionDate");
                                  onChange(date);
                                  if (
                                    !toCompletionDate ||
                                    date?.toDate()?.getTime() > new Date(toCompletionDate).getTime()
                                  ) {
                                    // Set the value of toCompletionDate to the same as toCompletionDate
                                    setValue("toCompletionDate", date);
                                  }
                                }}
                              />
                            )}
                          />
                        </Col>
                        <Col lg="6" xs="12" className="tb-reponsive px-2">
                          <Controller
                            name="toCompletionDate"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <ShamsiDatePicker value={value} onChange={onChange} placeholder="تا تاریخ موثر" />
                            )}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" className="tb-reponsive px-3">
                          <Button variant="secondary" type="submit" disabled={isSubmitting} className="w-100">
                            {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                            <SearchIcon />
                            جستجو
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Accordion.Body>
                </Card>
              </Accordion>
              {/* search box */}
              {/* <div className='border-top pt-3'>
                                <InputGroup className="mb-3">
                                    <Controller
                                        name="globalSearch"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <FormControl
                                                type="text"
                                                aria-describedby="basic-addon1"
                                                placeholder='جستجو ...'
                                                name="globalSearch"
                                                value={value || ""}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                   
                                        <Button variant="secondary" type="submit"><SearchIcon /></Button>
                                    
                                </InputGroup>
                            </div> */}
              {/* table */}
              {!_.isEmpty(agency) ? (
                <Card>
                  <Card.Body>
                    <Col xs="12" className="tb-reponsive px-0">
                      <Row>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">نام آژانس :</span>
                          {agency.name}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">شماره تماس :</span>
                          {agency.phoneNumber}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">شماره موبایل :</span>
                          {agency.mobileNumber}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">نام مدیر :</span>
                          {agency.managerName}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">نام فروشنده :</span>
                          {agency.salesManagerName}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">وضعیت:</span>
                          {agency.status ? "فعال" : "غیر فعال"}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">شهر :</span>
                          {agency.city}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">ایمیل :</span>
                          {agency.email}
                        </Col>
                        <Col xs="12" md="6" xl="4">
                          <span className="card-label font-weight-bolder text-dark">شماره فکس :</span>
                          {agency.faxNumber}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12">
                          <span className="card-label font-weight-bolder text-dark">ادرس :</span>
                          {agency.address}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12">
                          <span className="card-label font-weight-bolder text-dark">مانده حساب :</span>
                          {agency.balance < 0 ? (
                            <>
                              <ArrowDownwardIcon />
                              <span className="text-danger pr-2">
                                <SplitNumber number={Math.abs(agency.balance)} />
                              </span>
                              بدهکاری
                            </>
                          ) : (
                            <>
                              <ArrowUpwardIcon />
                              <span className="text-success pr-2">
                                <SplitNumber number={Math.abs(agency.balance)} />
                              </span>
                              بستانکاری
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Card.Body>
                </Card>
              ) : (
                <></>
              )}
              {!_.isEmpty(listData) ? (
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    idAgency={agency?.id}
                    setShowModalAgencyTransaction={setShowModalAgencyTransaction}
                    setSelectedAgencyTransaction={setSelectedAgencyTransaction}
                  />
                </Col>
              ) : (
                <></>
              )}
              {showModalAgencyTransaction && (
                <ViewModal
                  showModalAgencyTransaction={showModalAgencyTransaction}
                  setShowModalAgencyTransaction={setShowModalAgencyTransaction}
                  selectedAgencyTransaction={selectedAgencyTransaction}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default AgencyTransaction;
